import {RatingStatisticsModel} from "../models/domain/ratingStatisticsModel";
import {useAppContext} from "./useAppContext";
import {useFragment} from "@apollo/client";
import {RATING_STATISTICS_FRAGMENT} from "../definitions/fragments";
import {ItemClassificationType} from "../definitions/enums";
import {useMemo} from "react";
import {RatingStatisticsType} from "../definitions/types";

export const useProductRatingStatisticsFragment = () => {
    const {productId, primaryId} = useAppContext();

    const {complete, data} = useFragment({
        fragment: RATING_STATISTICS_FRAGMENT,
        fragmentName: "RatingStatisticsFragment",
        from: {
            __typename: "RatingStatistics",
            id: primaryId ?? productId,
            type: primaryId ? ItemClassificationType.Primary : ItemClassificationType.Standalone
        },
    });

    const model = useMemo(() => complete && data ?
        new RatingStatisticsModel(data as RatingStatisticsType) :
        new RatingStatisticsModel(null), [complete, data]);

    return {loading: !complete, model};
}